import { Component } from '@angular/core';

@Component({
  selector: 'app-manager-queue',
  templateUrl: './queue.component.html',
  styleUrls: ['./queue.component.scss'],
})
export class ManagerQueueComponent {
}
